import React, { useEffect } from 'react'
import CheckingAccountsContainer from '../containers/CheckingAccounts'
import Nav from '../components/nav/Nav';

const CheckingAccounts: React.FC= () => {

  useEffect(() => {
    document.title = 'Elite Community CU | Checking Accounts';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "Share Draft (Checking) Accounts A Credit Union Share Draft account is an alternative to a traditional checking account at a bank and offers you ...";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <Nav />
      <CheckingAccountsContainer />
    </div>
  )
}

export default CheckingAccounts